// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/scss/custom.scss'; // Import custom styles

let app = createApp(App)

app.use(router).mount('#app');
